/**
 * Bitamin Naturals — Deferred Script Loader
 * Drop this in Shopify: Online Store > Themes > Assets > deferred-loader.js
 * Then load it from theme.liquid: <script src="{{ 'deferred-loader.js' | asset_url }}" defer></script>
 *
 * Configure the SCRIPTS array below — no other file needs touching.
 */

(function () {
  'use strict';

  var SCRIPTS = [
    {
      id: 'gtm',
      type: 'inline',
      delay: '2000',
      pages: 'all',
      code: function () {
        (function (w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
          var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-K8S5M9RZ' + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-K8S5M9RZ');
      },
    },
    {
      id: 'facebook-pixel',
      type: 'inline',
      delay: 500,
      pages: 'all',
      code: function () {
        !(function (f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = true;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = true;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '900302808255934');
        fbq('init', '2961384344015898');
        fbq('track', 'PageView');
      },
    },
    {
      id: 'hotjar',
      type: 'inline',
      delay: 1000,
      pages: 'all',
      code: function () {
        (function (h, o, t, j, a, r) {
          h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments); };
          h._hjSettings = { hjid: 3809248, hjsv: 6 };
          a = o.getElementsByTagName('head')[0];
          r = o.createElement('script');
          r.async = 1;
          r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
          a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
      },
    },
    {
      id: 'clarity',
      type: 'inline',
      delay: 1500,
      pages: 'all',
      code: function () {
        (function (c, l, a, r, i, t, y) {
          c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
          t = l.createElement(r);
          t.async = 1;
          t.src = 'https://www.clarity.ms/tag/' + i;
          y = l.getElementsByTagName(r)[0];
          y.parentNode.insertBefore(t, y);
        })(window, document, 'clarity', 'script', 'rb7q81oi1v');
      },
    },
    {
      id: 'zoko',
      type: 'src',
      src: 'https://atlantis.live.zoko.io/scripts/main.js?v=v2&shop=b7abe7-2.myshopify.com',
      delay: 'scroll',
      pages: 'all',
    },
    {
      id: 'shiprocket',
      type: 'iframe',
      src: 'https://sr-cdn.shiprocket.in/static/uc.js?channel_id=',
      delay: 'scroll',
      pages: 'all',
    },
  ];

  var loaded = {};
  var interactionFired = false;

  function getPageType() {
    var body = document.body;
    if (body.classList.contains('template-index')) return 'index';
    if (body.classList.contains('template-product')) return 'product';
    if (body.classList.contains('template-collection')) return 'collection';
    if (body.classList.contains('template-cart')) return 'cart';
    return 'other';
  }

  function shouldLoadOnPage(pages) {
    if (pages === 'all') return true;
    if (!Array.isArray(pages)) pages = [pages];
    return pages.indexOf(getPageType()) !== -1;
  }

  function loadScript(script) {
    if (loaded[script.id]) return;
    if (!shouldLoadOnPage(script.pages)) return;
    loaded[script.id] = true;

    if (script.type === 'inline') {
      try { script.code(); } catch (e) { console.warn('Deferred loader:', script.id, e); }
    } else if (script.type === 'src') {
      var s = document.createElement('script');
      s.async = true;
      s.src = script.src;
      document.head.appendChild(s);
    } else if (script.type === 'iframe') {
      var f = document.createElement('iframe');
      f.src = script.src;
      f.style.cssText = 'display:none;width:0;height:0;border:0';
      document.body.appendChild(f);
    }
  }

  function loadByDelay(delayType) {
    SCRIPTS.forEach(function (script) {
      if (script.delay === delayType) loadScript(script);
    });
  }

  function loadByMs(ms) {
    SCRIPTS.forEach(function (script) {
      if (script.delay === ms) loadScript(script);
    });
  }

  function onInteraction() {
    if (interactionFired) return;
    interactionFired = true;
    loadByDelay('interaction');
    setTimeout(function () { loadByMs(500); }, 500);
    setTimeout(function () { loadByMs(1000); }, 1000);
    setTimeout(function () { loadByMs(1500); }, 1500);
    setTimeout(function () { loadByMs(2000); }, 2000);
  }

  function onScroll() {
    loadByDelay('scroll');
  }

  ['scroll', 'click', 'keydown', 'touchstart', 'mousemove'].forEach(function (evt) {
    window.addEventListener(evt, onInteraction, { once: true, passive: true });
  });

  window.addEventListener('scroll', onScroll, { once: true, passive: true });

  setTimeout(function () {
    onInteraction();
    onScroll();
  }, 3500);

})();